
if(window.jQuery)  init();
else{
    var script = document.createElement('script');
    document.head.appendChild(script);
    script.type = 'text/javascript';
    script.src = "https://code.jquery.com/jquery-3.2.1.js";
    script.onload = init;
}

function init(){

    //var currency = shop_currency.replace("{{amount_no_decimals}}", "");

    var checkout_button_extend = 'form[action*="/cart"] [name="checkout"],' +
    "#dropdown-cart button.btn.btn-checkout.show," +
    'a.button.checkout-button[href="/checkout"],' +
    'form[action*="/checkout"] .add_to_cart,' +
    'form[action*="/cart"]#cart_form #checkout,' +
    'form[action*="/cart"] button.Cart__Checkout,' +
    'form[action*="/cart"] button.cart__checkout,' +
    'a.btn.disabled.ttmodalbtn[href="/checkout"],' +
    'form[action*="/cart"] [name="checkout"][type="submit"],' +
    "button.Cart__Checkout.Button.Button--primary.Button--full," +
    ".baskettop button.mini-cart-checkout," +
    ".tt-dropdown-menu .btn.itemCheckout," +
    ".bss-btn-checkout-mini-cart," +
    'button[name="checkout"].btn,' +
    'form[action*="/checkout"] [name="checkout"],' +
    ".cart__footer .cart__checkout-button.button," +
    "#cartform #checkout," +
    `#slidedown-cart button[onclick="window.location='/checkout'"],` +
    "#dropdown-cart button.btn.btn-checkout," +
    'form[action*="/cart"] button[type="submit"].c-btn.c-btn--light.cart__button-update.update-cart,' +
    'form[action*="/cart"] .sp-proceed-to-checkout a[href="/checkout/"]';
    

    if(!payment_options_target_class){
        payment_options_target_class = "[name=checkout]:last";
    }

    var checkout_button = '#checkout, #cml_checkout_button, a[href="/checkout"], a[href$="checkout"]:not(.cml_ignore), [name="checkout"], button[name="checkout"]:not(.pbc_ignore), [name="goto_pp"], [name="goto_gc"], form[action="/cart"] [type="submit"][name="checkout"], form[action="/cart"] [type="image"], form#cartform [type="image"], form#cartform [type="submit"],'+ payment_options_target_class;

    var instantPayment = false;

    // This code will show the pay later checkout page if customer is on checkout page
    if (window.location.href.indexOf("pages/cml_checkout") > -1) {
        $("body").hide();
    }

    
    
    
    setTimeout(() => {

        // Code to relocate the payment options 
        if($("#CML_select_payments").length){
            
            if(!payment_options_target_class){
                payment_options_target_class = "[name=checkout]:last";
            }
            
            $("#CML_select_payments").show();

            var payment_options_html = $("#CML_select_payments")[0].outerHTML;

            $("#CML_select_payments").remove();
            $(payment_options_target_class).parent().before(payment_options_html);

            if($(payment_options_target_class).length && storeArguments.customer){
              
                $.ajax("/apps/create-cml-order", {
                  type: "post",
                  dataType: "json",
                  crossDomain: true,
                  data: {
                    action: "get_discount_pay_now"
                  },
                  beforeSend: function(){
                      //todo: show inbuilt loader
                  },
                  success: function (data) {
                    console.log(data.is_pay_now_discount_enable);
    
                    if(data.is_pay_now_discount_enable){
                        instantPayment = true;
    
                        $("#CML_select_payments").before("<p class='cml_pay_now_text' style='text-align: right'>"+ data.pay_now_discount_text +"</p>");
                        
                      }
                  }
                });
            }

            let option = $(".CML_payments_options").val();

            if(typeof option != "undefined" && option != ''){
                set_payment(option);
            }

            $(document).on("change", ".CML_payments_options", function(){
                set_payment($(this).val());
            });

            function set_payment(option){
                if(is_onchange_activate){

                    if(option == "pay_later"){
                        $(checkout_button).attr("name", "");
                    }else{
                        $(checkout_button).attr("name", "checkout");
                    }
                }
            }
                        
        }
        // END

        // This code will show the pay later checkout page if customer is on checkout page
        if (window.location.href.indexOf("pages/cml_checkout") > -1) {
            $("body").show();
            if(!cml_checkout_target_class)
                cml_checkout_target_class = "body";
            
            var cml_checkout_html = $("#cml_checkout_wrapper").html();

            $(cml_checkout_target_class).html(cml_checkout_html);
            // $("#cml_checkout_start").show();
            $("#cml_checkout_wrapper").remove();
                        
            $('head').append('<link rel="stylesheet" href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css" type="text/css" />');
        }else
            $("#cml_checkout_wrapper").remove();
        // END

        convert_to_euro_price();

        
      
      

    }, 500);

    if (typeof Shopify.getCart === "undefined" || typeof Shopify.getCart === undefined) {
        Shopify.getCart = function (t) {
            jQuery.getJSON("/cart.js", function (r) {
                if ("function" == typeof t)
                    t(r);
            })
        };
    }

    if (typeof Shopify.clear === "undefined" || typeof Shopify.clear === undefined) {
        Shopify.clear = function (t) {
            var r = {
                type: "POST",
                url: "/cart/clear.js",
                data: "",
                dataType: "json",
                success: function (r) {
                    t(r);
                },
                error: function (t, r) {
                    Shopify.onError(t, r);
                }
            };
            jQuery.ajax(r);
        };
    }

    (function($){

        $(function () {

            //load disconuted prices on cart page if available
            // if (window.location.href.indexOf("/cart") > -1) {
            //     setTimeout(() => {
            //       load_cml_prices();
            //     }, 500);
            // }

            if (window.location.href.indexOf("pages/cml_checkout") > -1) {
                setTimeout(() => {
                    new Shopify.CountryProvinceSelector(
                        'AddressCountry',
                        'AddressProvince',
                        { hideElement: 'AddressProvinceContainer' }
                    );
                }, 500);

                if(typeof extra_fields != "undefined"){
                    var field_required = "";
                    extra_fields.forEach(element => {
                        if(element.required){
                          field_required = "required";
                        }
                        var add_field = '<input class="form-control" type="text" name="'+ element.field_name.replace(/ /g, "_") +'" id="'+ element.field_name.replace(/ /g, "_") +'" placeholder="'+ element.field_name +'" '+ field_required +'>';
                        $("#address-form .form-control:nth-child("+ element.field_position +")").after(add_field);
                        console.log(element.field_name);
                    }); 
                }
            }
      
            // calculate shipping on change country OR state
            $(document).on('change', '#address-form #AddressCountry, #address-form #AddressProvince', function(){
                //var shippingAddress = { country:$('#AddressCountry').val(), province:$('#AddressProvince').val(), zip : $('#zipCode').val() };
                //shipping(shippingAddress);
            });
      
            // calculate shipping charges
            $(document).on("submit", "#address-form", function(e){
                var shippingAddress = { country:$('#AddressCountry').val(), province:$('#AddressProvince').val(), zip : $('#zipCode').val() };
                shipping(shippingAddress);
                return false;
            });
      
            
      
            var shippingDone = false;
            var shipping_trigger = 0;
            var shipping_trigger_first = 0;
      
            var shipping = function(shippingAddress){
      
                // hide the place order button
                $('#checkout_place_order').hide();
                $(".shipping_charges").show();
                shipping_trigger_first++;
      
                var t = {
                  type: "POST",
                  url: "/cart/prepare_shipping_rates",
                  dataType: 'json',
                  data: jQuery.param({
                    shipping_address: shippingAddress
                  }),
                  beforeSend: function(){
                    $(".error").hide().html('');
                  },
                  success: function(){
                    setTimeout(function(){
                        CalculateShipping();
                      }, 1000);
                  },
                  complete: function(){
                    //$(".shipping_charges").hide();
                  },
                  error: function(data){
                    for (var key in data.responseJSON) {
                      switch(key){
                        case 'zip':
                          $("#zipCode").focus();
                          $(".zipcode.error").show().html("Zipcode is not valid");
                          break;
                        case 'country':
                          $("#AddressCountry").focus();
                          $(".country.error").show().html("Country is not supported");
                          break;
                        default: 
                        if(shipping_trigger_first == 5){
                            show_order_button();
                        }
                        shipping(shippingAddress);
                          //alert("Cannot find the shipping charges");
                          //$('#checkout_place_order').show().focus();
                      }
                    }
                  }
                };
                jQuery.ajax(t)
              
                var CalculateShipping = function(){
      
                  jQuery.ajax("/cart/async_shipping_rates", {
                    dataType: "json",
                    success: function(result, n, a) {
                      var arr = [];
                      var max = 9999;
                      var show_shipping = true;
                      var html = '';
                      shipping_trigger++;
      
                      if(result != null && result.shipping_rates && result.shipping_rates.length > 0){
      
                        // code to show the shipping rates to select first
                        if(show_shipping){
      
                          var shippings = result.shipping_rates;

                          var rate = Number(Shopify.currency.rate);
                          
                          for(var i=0; i<shippings.length; i++){

                            var ship_price = (shippings[i].price * rate).toFixed(2);
                            arr.push({id: shippings[i].carrier_service_id, price: shippings[i].price, name: shippings[i].name});
      
                            // prepare HTML for shipping
                            html += "<div class='shipping-row'><div class='select-wrapper'>";
                            html += "<input type='radio' name='address[shipping_charges]' value='"+ [shippings[i].name.replace(",", "").replace("'", ""), shippings[i].price, ship_price] +"'>";
                            html += "<span>" + shippings[i].name + "</span></div>";
                            html += "<span class='price-row'>" + ship_price + "</span></div>";
      
                          }
      
                          $(".shipping_container").html(html);
      
                          // auto select the first option
                          $(".shipping_container input:first").attr('checked', true).change();
                          $(".shipping").show();
      
                          // hide continue button now
                          $("#place_order").hide();
      
                        }
                      }
                      else if(result === null){
                        
                        if(shipping_trigger == 5){
                          show_order_button();
                        }
                        CalculateShipping();
                        
                      }
                      else if(result.shipping_rates.length == 0){
                          alert("No shipping found");
                          $(".shipping_container").html('');
                      }else{
                        show_order_button();
                        //$(".shipping_container").html('');
                      }
      
                    },
                    error: function(error){

                        var er = JSON.parse(error.responseText);
        
                        if (er.error == "This cart does not require shipping"){
                          show_order_button();
                        }
                        
                    },
                    complete: function(){
                      $(".shipping_charges").hide();
                    }
                  })
                }
            };
  
            // if want to show the shipping first
            $(document).on("change", ".shipping_container input", function(){
    
                var ship_price = $(this).val().split(',');
                var ship_name = $(this).next('span').html();
        
                $('.shipping .itemName span').html(ship_name);
                $('.shipping .price').html(ship_price[2]);
        
                var total_price = $(".grand_total .price").data("price");
                // add shipping charges in total
                var totalPrice = parseFloat(total_price) / 100;
        
                var total = parseFloat(totalPrice) + parseFloat(ship_price[2]);
                $('.total .price').html(total.toFixed(2));
        
                show_order_button();
    
            });

            if(window.location.href.indexOf("pages/cml_checkout") > -1) {
                Shopify.getCart(function (data) {
                    if (!data.items.length) {
                        alert("There are no items in the cart. Redirecting to home page.");
                        window.location = "/";
                    }
                });
            }

            if (!$.fn.on) {
                $.fn.on = function (events, selector, callback) {
                    $(document).delegate(selector, events, callback);
                }
            }

            function createOrder(customerId, address, $submit, cartData, customer_email) {

                var $self = $(this);

                if ( $self.data('requestRunning') ) {
                    return;
                }

                $self.data('requestRunning', true);

                var shippingAddress = {};
                var valid = true;
                var attributes = {};

                if(typeof extra_fields != "undefined"){
                    
                    extra_fields.forEach(element => {

                        var field_key = element.field_name.replace(/ /g, "_");
                        attributes[field_key] = $("#" + field_key).val();

                    });
                }

                //var attributes = {purchase_number: $("#purchase_number").val()};
                if ($('.submit-address').length) {
                    $('.submit-address').find('[name^="address"]').each(function () {

                        shippingAddress[this.name.replace('address[', '').replace(']', '')] = this.value;

                    });
                }

                shippingAddress['shipping_charges'] = $('.submit-address').find('[name="address[shipping_charges]"]:checked').val();

                cartData.discount = '';
                if ($('#discount').val()) {
                    cartData.discount = $('#discount').val();
                }

                cartData.note = '';
                if ($('#note').val()) {
                    cartData.note = $('#note').val();
                }

                var customer_email = $("input[name=email]").val();


                for (const property in cartData.items) {
    
                        //for (const discount in discounts) {

                          var c_v_id = cartData.items[property]['variant_id'];
                      
                          var app_price = Number($("[data-variant-id="+ c_v_id +"] .price").attr("data-discount-price"));

                          // get currency rate
                          var c_rate = Number(Shopify.currency.rate);

                          var price_after_rate = (c_rate * (app_price/100));

                          var currency = Shopify.currency.active;
                          
                          if(currency == "EUR"){
                            const surchargeRate = 0.20;
                          
                              price_after_rate = price_after_rate + (price_after_rate * surchargeRate);  
                          }
                      
                           if(cartData.items[property]['original_price'] != app_price){
                                //console.log(discounts[discount]['id']);
    
                                cartData.items[property]['discounted_price'] = ((price_after_rate*100)/cartData.items[property]['quantity']).toFixed(2);
                                cartData.items[property]['rate'] = c_rate;
    
                                //break;
                            }
    
                        //}
    
    
                        //console.log(`${property}: ${cartData.items[property]['variant_id']}`);
                  }

                  console.log(shippingAddress);
              // return;
              

                shippingAddress.shipping_charges = shippingAddress.shipping_charges.replace(/,\d+(\.\d+)?$/, '');
              
                var post_data = {
                    customer: customerId,
                    address: address,
                    cart: cartData,
                    shipping_address: shippingAddress,
                    attributes: attributes,
                    customer_email: customer_email
                };

                if($("#cml_billing_snippet").length){
                    var billingAddress = {};
                    if ($('.submit-address').length) {
                        $('.submit-address').find('[name^="billing_address"]').each(function () {

                            billingAddress[this.name.replace('billing_address[', '').replace(']', '')] = this.value;

                        });
                    }

                    post_data.billing_address = billingAddress;
                }

                $.ajax("/apps/create-cml-order", {
                    type: "post",
                    dataType: "json",
                    crossDomain: true,
                    data: post_data,
                    success: function (data) {
                        if (data.success) {
                            $.ajax({
                                type: 'POST',
                                url: "/cart/clear.js",
                                success: function(data){
                                    show_popup();
                                },
                                complete: function(data){
                                    show_popup();
                                }
                            });
                        } else {
                            alert(data.error);
                        }
                    },
                    error: function () {
                        alert("An error occurred creating the order, please try again.");
                    },
                    complete: function (){
                        hide_loader();

                        $self.data('requestRunning', false);

                    }
                });

            }

            function handleCheckout(e) {
    
                    e.preventDefault();
    
                    var payment_options = "pay_later";
                    if($(".CML_payments_options").val() != '' && typeof $(".CML_payments_options").val() != 'undefined'){
                        payment_options = $(".CML_payments_options").val();
                    }
    
                    if(payment_options == "pay_now" || storeArguments.instantPaymentTag){
    
                        pay_instant();
    
                    }else{
    
                        var $self = $(this);
    
                        var checkout_page = "/pages/cml_checkout";
    
                        show_loader();
    
                        if ( $self.data('requestRunning') ) {
                            return;
                        }
    
                        $self.data('requestRunning', true);
    
                        $.ajax({
                            type: 'GET',
                            url: "/cart.js",
                            dataType: "json",
                            success: function(data){
                                if (!data.items.length) {
                                    alert("There are no items in the cart");
                                } else {
    
                                    // temp fix until we know everyone has installed the new confirmation page
                                    $.ajax({
                                        type: 'HEAD',
                                        url: checkout_page,
                                        success: function () {
                                            if ($self.hasClass('checkout-skipper')) {
                                                if ($('[name="note"]').length)
                                                    data['note'] = $('[name="note"]').val();
                                                createOrder(storeArguments.customer, storeArguments.shopAddress, $self, data, storeArguments.customer_email);
                                            } else {
                                                window.location.href = checkout_page;
                                            }
                                        },
                                        error: function () {
                                            // page does not exist
                                            if ($('[name="note"]').length)
                                                data['note'] = $('[name="note"]').val();
                                            createOrder(storeArguments.customer, storeArguments.shopAddress, $self, data, storeArguments.customer_email);
                                        },
                                        complete: function(){
                                            $self.data('requestRunning', false);
                                        }
                                    });
                                }
                            }
                        });
                    }
                }

            function show_loader(){
                $(".loader").css("display", "inline-block");
                $("#checkout_place_order").hide();
            }

            function hide_loader(){
                $(".loader").hide();
                $("#checkout_place_order").css("display", "inline-block");
            }

            $(document).on("click", "#checkout_place_order", handleCheckout);

            $('[onclick="window.location=\'/checkout\'"]').each(function () {
                $(this).removeAttr('onclick');
                $(this).click(handleCheckout);
            });

            // when the cart action is /cart we need to handle submit buttons with the name "checkout"
            $(document).on('click', "#cart-icon-bubble", function (e) {
              window.location = "/cart";
            });
          
            $(document).on('click', checkout_button, function (e) {

                var payment_options = "pay_later";
                if($(".CML_payments_options").val() != '' && typeof $(".CML_payments_options").val() != 'undefined'){
                    payment_options = $(".CML_payments_options").val();
                }

                //var instantPayment = false;
                if(payment_options == "pay_now" && discounted_price_available){
                    instantPayment = true;
                }

                if($("[name='note']").val() != ''){
                    localStorage.setItem("notes", $("[name='note']").val());
                }
                

                if(payment_options == "pay_later" || instantPayment){
                    handleCheckout(e);
                }
            });

            $(document).on('submit', 'form[action="/cart"] [name="checkout"], form[action="/checkout"], form#cartform', function (e) {

                var payment_options = "pay_later";
                if($(".CML_payments_options").val() != '' && typeof $(".CML_payments_options").val() != 'undefined'){
                    payment_options = $(".CML_payments_options").val();
                }

                if(payment_options == "pay_later" || storeArguments.instantPayment){
                    handleCheckout(e);
                }
            });

            // prevent trade order customers from being redirected to checkout after logging in
            $('#customer_login input[name="checkout_url"]').remove();

            // remove any checkout with paypal buttons if trade orders is active
            $('.additional-checkout-buttons, .additional_checkout_buttons').remove();

            /* draft orders table start */
            if($("#CML_draft_orders").length > 0){
                // call to show the draft orders
                get_draft_orders();
            }

            // setup draft orders table pagination
            $(document).on("click", ".cml_pagination span", function(){

                // call to show the draft orders
                get_draft_orders($(this).data("cursor"), $(this).attr('class'));

            })
            /* draft orders table end */

            // discount feature
            $(".discount_btn").click(function(){

                var discount = $("#discount").val();
                var th = $(this);

                if(discount != ''){

                    if(th.data('ajaxRunning')){return false;}

                    $.ajax({
                        url: "/apps/create-cml-order/" + $("#discount").val(),
                        beforeSend: function(){

                            th.data('ajaxRunning', true);
                            th.css("opacity", '0.2');
                        },
                        dataType: 'json',
                        success: function(data){

                            //console.log(data);

                            if(!$.isEmptyObject( data )){


                                // first of all check if valid coupon or already used
                                if(!data.already_used){

                                    let totalPrc = $(".total .price").data("price");

                                    totalPrc = parseFloat(totalPrc/100);

                                    var final_item_discount = 0;

                                    if(data.type == 'fixed_amount'){

                                        // now check whether the discount is for only a item

                                        if(typeof data.target_selection !== 'undefined' && data.target_selection  == "entitled"){


                                            if (typeof data.entitled_variant_ids !== 'undefined') {

                                                for(var ids in data.entitled_variant_ids){

                                                    // discount on VARIANT

                                                    var target_item = $("ul").find('[data-variant_id='+ data.entitled_variant_ids[ids] +']');

                                                    var target_item_price = target_item.data("price").toString();

                                                    var target_item_qty = target_item.find(".cml_qty").html().trim();

                                                    var item_discount = (Number(target_item_price.slice(0, -2)) * target_item_qty) - data.amount;

                                                    target_item.find(".price").addClass("cut-price");

                                                    target_item.find(".discounted_item_price").html(item_discount);

                                                    final_item_discount += item_discount;

                                                }

                                            }

                                            if (typeof data.entitled_product_ids !== 'undefined') {

                                                for(var ids in data.entitled_product_ids){

                                                    // discount on PRODUCT
                                                    var target_item = $("ul").find('[data-product_id='+ data.entitled_product_ids[ids] +']');


                                                    var target_item_price = target_item.data("price").toString();

                                                    var target_item_qty = target_item.find(".cml_qty").html().trim();

                                                    var item_discount = Number(target_item_price.slice(0, -2)) - data.amount;

                                                    target_item.find(".price").addClass("cut-price");

                                                    target_item.find(".discounted_item_price").html(item_discount);

                                                    final_item_discount += item_discount;

                                                }

                                            }

                                            var total = final_item_discount;

                                        }else{
                                            var total = Number(totalPrc.slice(0, -2)) - data.amount;
                                        }


                                    }else if(data.type == 'percentage'){

                                        if(typeof data.target_selection !== 'undefined' && data.target_selection  == "entitled"){


                                            if (typeof data.entitled_variant_ids !== 'undefined') {

                                                for(var ids in data.entitled_variant_ids){

                                                    // discount on VARIANT

                                                    var target_item = $("ul").find('[data-variant_id='+ data.entitled_variant_ids[ids] +']');

                                                    var target_item_price = target_item.data("price").toString();

                                                    var target_item_qty = target_item.find(".cml_qty").html().trim();

                                                    var item_discount = Number(target_item_price.slice(0, -2)) - (data.amount/100) * Number(target_item_price.slice(0, -2)) ;

                                                    target_item.find(".price").addClass("cut-price");

                                                    target_item.find(".discounted_item_price").html(item_discount);

                                                    final_item_discount += item_discount;

                                                }

                                            }

                                            if (typeof data.entitled_product_ids !== 'undefined') {

                                                for(var ids in data.entitled_product_ids){

                                                    // discount on PRODUCT
                                                    var target_item = $("ul").find('[data-product_id='+ data.entitled_product_ids[ids] +']');


                                                    var target_item_price = target_item.data("price").toString();

                                                    var target_item_qty = target_item.find(".cml_qty").html().trim();

                                                    var item_discount = Number(target_item_price.slice(0, -2)) - (data.amount/100) * Number(target_item_price.slice(0, -2)) ;

                                                    target_item.find(".price").addClass("cut-price");

                                                    target_item.find(".discounted_item_price").html(item_discount);

                                                    final_item_discount += item_discount;

                                                }

                                            }

                                            var total = final_item_discount;

                                        }else{

                                            var total = totalPrc - ((data.amount/100) * totalPrc) ;
                                        }

                                    }else{

                                        console.log('No type defined');

                                    }

                                    //console.log(total);

                                    $(".total .price").addClass("cut-price");



                                    $(".discounted_price").html(total + Number($(".shipping .price").html()));

                                    // add coupon after discount
                                    $('.after_discount').show();
                                    $(".discount-code").html(discount);
                                    //$("#discount").val('');

                                }else{

                                    alert("You have used this coupon already.");
                                    $("#discount").val("");

                                }
                            }else{

                                alert("No coupon found.");

                            }

                        },
                        complete: function(){

                            th.css("opacity", '1');
                            th.data('ajaxRunning', false);

                        }
                    })

                }else{

                    alert("Discount code cannot be empty");

                }


            });

        });
    }(jQuery));
    
}

function convert_to_euro_price() {

  // code to set discounted price same as currency
  $(".disc_price").each(function() {
    var disc_price = Number($(this).attr("data-disc-price"));
  
    var rate = Number(Shopify.currency.rate);
  
    if(rate != 1 && !isNaN(disc_price)){
      var final_disc_price = ((disc_price/100)*rate).toFixed(2);
  
      var disc_price_number = Number(final_disc_price);

      var currency = Shopify.currency.active;
      
      if(currency == "EUR"){
        const surchargeRate = 0.30;
      
          final_disc_price = (disc_price_number + (disc_price_number * surchargeRate)).toFixed(2);  
          disc_price_number = Number(final_disc_price);
      }
      
      var final_disc_price = shop_currency.replace("{{amount_no_decimals}}", final_disc_price).replace("{{amount}}", final_disc_price).replace("{{amount_with_comma_separator}}", final_disc_price);
  
      $(this).html(final_disc_price);
  
      $(this).parents(".grand_total").find(".price").attr("data-price", disc_price_number*100).attr("data-price-fixed", disc_price_number*100);  
    }
  
});
  
}
function show_popup() {
    // Initialize Variables
    var overlay = document.getElementById("overlay");
    var popup = document.getElementById("popup");
    overlay.style.display = 'block';
    popup.style.display = 'block';
}

function hide_popup() {
    // Initialize Variables
    var overlay = document.getElementById("overlay");
    var popup = document.getElementById("popup");
    overlay.style.display = 'none';
    popup.style.display = 'none';
    // similar behavior as clicking on a link
    window.location.href = '/';
}

function show_order_button(){
    $('#checkout_place_order').css("display", "inline-block").focus();
    $('.error').hide().html('');
    $(".shipping_charges").hide();
    return true;
}

function load_cml_prices(){

    $.getJSON("/cart.js", function (data) {
      if (!data.items.length) {
          alert("There are no items in the cart");
      } else {
          var targetPriceClass = ".cart-item__totals .price";
          var product_ids = [];
  
          var items = data.items;
        
          for (var item in items) {
            product_ids.push({"product-id": items[item].product_id, "variant-id": items[item].variant_id});
          }
        
          $.ajax("/apps/create-cml-order", {
            type: "post",
            dataType: "json",
            crossDomain: true,
            data: {
                product_ids: JSON.stringify(product_ids),
                action: "get_disconuted_prices",
                customer_id: storeArguments.customer
              },
              beforeSend: function(){
                  //todo: show inbuilt loader
              },
              success: function (data) {
                var i = 0, total_price = 0;
                for (const property in data) {
                  for (var item in items) {
                    if(property == items[item].variant_id && data[property] != "0.00"){
                      var qty = items[item].quantity;
                      var final_item_price = qty * parseFloat(data[property]);
  
                      total_price += final_item_price;
                      $( 'tr.cart-item' ).eq( i ).find(targetPriceClass).html(final_item_price);                     
                      
                    }else if(property == items[item].variant_id && data[property] == "0.00"){
                      total_price += parseFloat(items[item].final_line_price/100);
                    }
                  }
                  
                  //console.log(Shopify.formatMoney(data[property], '${{amount}}'));
                  i++
                }
  
                $(".totals__subtotal-value").html(total_price);
                console.log(total_price);
              },
              error: function () {
                //alert("An error occurred creating the order, please try again.");
              },
              complete: function (){
                  // $(targetPriceClass).show();
                  // $(".featching_discounts").hide();
              }
            });
        }
    });
}

function pay_instant_ajax() {
  
    Shopify.getCart(function (data) {
        if (!data.items.length) {
            alert("There are no items in the cart");
        } else {

          if (localStorage.getItem("discounts") !== null) {
            var discounts = JSON.parse(localStorage.getItem("discounts"));

            var cartData = data;
            for (const property in cartData.items) {
  
                for (const discount in discounts) {
  
                    if(discounts[discount]['id'] == cartData.items[property]['variant_id']){
                        //console.log(discounts[discount]['id']);
  
                        cartData.items[property]['discounted_price'] = discounts[discount]['discount'].replace("$", "");
  
                        break;
                    }
  
                }
  
  
                console.log(`${property}: ${cartData.items[property]['variant_id']}`);
            }
          }          
          
          console.log(cartData);//return false;
          
          var post_data = {customer: storeArguments.customer,address: storeArguments.shopAddress,cart: cartData, instant: true, action: "discount_prices"};
  
          console.log(post_data);//return;
          $.ajax({
              type: "POST",
              url: "/apps/create-cml-order",
              data: post_data,
              dataType: "json",
              beforeSend: () => {
                  $("[name=checkout]").attr("disabled","disabled").after("<p class='cml_loader'>Processing...</p>");
                  
              },
              success: (data) => {
                  if (data.success) {
                      window.location = data.success.invoice_url;
                  } else {
                      alert(data.error);
                  }
              },
              complete: () => {
                $("[name=checkout]").removeAttr("disabled");
                $("body").find(".cml_loader").remove();
              }
              
          });
          
        }
    });
    
}

function pay_instant() {

    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {

            var http = new XMLHttpRequest();
            var url = '/apps/create-cml-order';
            var params = 'address='+ storeArguments.shopAddress +'&customer=' + storeArguments.customer + '&cart=' + this.responseText + '&instant=true';
            http.open('POST', url, true);

            //Send the proper header information along with the request
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

            http.onreadystatechange = function() {//Call a function when the state changes.
                if(this.readyState == 4 && this.status == 200) {

                    if(this.responseText == "Not a Gold Member"){
                        window.location = "/checkout";
                    }else{

                        var data = $.parseJSON(this.responseText);

                        console.log(data);

                        if(data.success){


                            window.location = data.success.invoice_url;
                            console.log(data.success.invoice_url);

                        }

                    }
                }
            }
            http.send(params);

        }
    };
    xhttp.open("GET", "/cart.js", true);
    xhttp.send();
}

function get_draft_orders(cursor, action){
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {

            var http = new XMLHttpRequest();
            var url = '/apps/create-cml-order';
            var params = 'address='+ storeArguments.shopAddress +'&customer=' + storeArguments.customer + '&action=draft_order_list' + "&cursor="+ cursor + "&pagination_action=" + action;
            http.open('POST', url, true);

            //Send the proper header information along with the request
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

            http.onreadystatechange = function() {//Call a function when the state changes.
                if(this.readyState == 4 && this.status == 200) {

                    document.getElementById('CML_draft_orders').innerHTML = this.responseText;
                }
            }
            http.send(params);

        }
    };
    xhttp.open("GET", "/cart.js", true);
    xhttp.send();
}

function extractCurrencySymbol(amount) {
    // Regular expression to match currency symbols
    const currencyRegex = /^[^\d.,]+|[^\d.,]+$/g;
    const match = amount.match(currencyRegex);
    return match ? match.join('').trim() : 'No currency symbol found';
}

